import { useIntl } from 'react-intl';

import FollowUpChip from '@/components/atom/FollowUpChip/FollowUpChip';

import { Container, Label, Wrapper } from './FollowUpChipList.styles';
import { TFollowUpChipListProps } from './types';

const FollowUpChipList = ({ followUps, onChipClick, disabled = false }: TFollowUpChipListProps) => {
  const intl = useIntl();

  if (followUps.length === 0) return null;

  return (
    <Wrapper
      aria-label={intl.formatMessage({ id: 'chatPage.followUpChips.ariaLabel' })}
      data-testid="follow-up-chip-list"
    >
      <Label data-testid="follow-up-chip-list-label">
        {intl.formatMessage({ id: 'chatPage.followUpChips.label' })}
      </Label>
      <Container>
        {followUps.map((text, index) => (
          <FollowUpChip key={text} text={text} index={index} disabled={disabled} onClick={onChipClick} />
        ))}
      </Container>
    </Wrapper>
  );
};

export default FollowUpChipList;
